namespace $.$$ {

	$mol_style_define( $shm_projects_goal, {

		flex: {
			direction: 'column',
		},
		minWidth: 0,

		Form: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Result: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Timeline: {
			gap: $mol_gap.block,
		},

		Clarifications: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},

		Clarifications_title: {
			font: { weight: 'bold' },
		},

		Clarifications_list: {
			gap: $mol_gap.block,
		},

		Clarification: {
			minWidth: 0,
		},

		Prerelease_status: {
			alignItems: 'stretch',
			gap: $mol_gap.block,
			flex: {
				direction: 'column',
			},
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
		},

		Prerelease_status_head: {
			alignItems: 'center',
			gap: $mol_gap.block,
			flex: {
				wrap: 'wrap',
			},
		},

		Prerelease_status_link: {
			font: { weight: 'bold' },
		},

		Prerelease_status_state: {
			flex: { grow: 1 },
		},

		Prerelease_status_elapsed: {
			color: $mol_theme.shade,
		},

		Iteration_status: {
			alignItems: 'stretch',
			gap: $mol_gap.block,
			flex: {
				direction: 'column',
			},
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
		},

		Iteration_status_head: {
			alignItems: 'center',
			gap: $mol_gap.block,
			flex: {
				wrap: 'wrap',
			},
		},

		Iteration_goal: {
			minWidth: 0,
		},

		Iteration_status_title: {
			font: {
				weight: 'bold',
			},
		},

		Iteration_status_link: {
			font: { weight: 'bold' },
		},

		Iteration_status_state: {
			flex: { grow: 1 },
		},

		Iteration_status_elapsed: {
			color: $mol_theme.shade,
		},

		Iteration_event: {
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
		},

		Iterations: {
			gap: $mol_gap.block,
		},

		Iteration: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},

		Iteration_title: {
			font: { weight: 'bold' },
			color: $mol_theme.shade,
		},

		Iteration_changes: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
		},

		Prerelease: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},

		Prerelease_title: {
			font: { weight: 'bold' },
		},

		Prerelease_events: {
			gap: $mol_gap.block,
		},

		Prerelease_event: {
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
		},

		Prerelease_changes: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
		},

		Prerelease_change: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},

		Prerelease_change_title: {
			font: { weight: 'bold' },
		},

		Prerelease_change_screenshots: {
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fill, minmax(12rem, 1fr))',
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Prerelease_change_demos: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
		},

		Prerelease_change_screenshot: {
			height: '9rem',
			padding: 0,
			overflow: 'hidden',
			border: {
				radius: $mol_gap.round,
				width: '1px',
				style: 'solid',
				color: $mol_theme.line,
			},
		},

		Result_change: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},

		Result_change_title: {
			font: { weight: 'bold' },
		},

		Result_change_screenshots: {
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fill, minmax(12rem, 1fr))',
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Result_change_demos: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
		},

		Result_change_screenshot: {
			height: '9rem',
			padding: 0,
			overflow: 'hidden',
			border: {
				radius: $mol_gap.round,
				width: '1px',
				style: 'solid',
				color: $mol_theme.line,
			},
		},

		Artifacts: {
			flex: {
				direction: 'column',
			},
		},

	} )

}
